import { lazy } from "react";
import { Navigate } from "react-router-dom";

import { routers } from "@/configs";

const Sports = lazy(() => import("@/pages/Sport/Sports"));
const SportEvent = lazy(() => import("@/pages/Sport/SportEvent"));
const SportsLobby = lazy(() => import("@/pages/Sport/SportsLobby"));
const SportsInPlay = lazy(() => import("@/pages/Sport/SportsInPlay"));
const SportsNext24 = lazy(() => import("@/pages/Sport/SportsNext24"));
const SportsUpcoming = lazy(() => import("@/pages/Sport/SportsUpcoming"));
const SportsFavorites = lazy(() => import("@/pages/Sport/SportsFavorites"));
const SportsPromotions = lazy(() => import("@/pages/Sport/SportsPromotions"));
const SportsSearch = lazy(() => import("@/pages/Sport/SportsSearch"));
const SportRegion = lazy(() => import("@/pages/Sport/SportRegion"));
const SportLeague = lazy(() => import("@/pages/Sport/SportLeague"));
const MyBets = lazy(() => import("@/pages/Profile/MyBets"));

export const SportRoutes = [
  {
    path: routers.SportsLobby,
    element: <SportsLobby />,
  },
  {
    // The old "home" link lands on the lobby too.
    path: routers.SportsHome,
    element: <Navigate to={routers.SportsLobby} replace />,
  },
  {
    path: routers.SportsInPlay,
    element: <SportsInPlay />,
  },
  {
    path: routers.SportsNext24,
    element: <SportsNext24 />,
  },
  {
    path: routers.SportsUpcoming,
    element: <SportsUpcoming />,
  },
  {
    path: routers.SportsFavorites,
    element: <SportsFavorites />,
  },
  {
    path: routers.SportsPromotions,
    element: <SportsPromotions />,
  },
  {
    path: routers.SportsSearch,
    element: <SportsSearch />,
  },
  {
    path: routers.SportRegion,
    element: <SportRegion />,
  },
  {
    path: routers.SportLeague,
    element: <SportLeague />,
  },
  {
    path: routers.Sports,
    element: <Sports />,
  },
  {
    path: routers.SportEvent,
    element: <SportEvent />,
  },
  {
    path: routers.MyBetsSport,
    element: <MyBets />,
  },
];
